import actions from './actions';

const {
  USERSPWDCHANGE_UPDATE_BEGIN,
  USERSPWDCHANGE_UPDATE_SUCCESS,
  USERSPWDCHANGE_UPDATE_ERR,
} = actions;

const updateStateSingle = {
  data: null,
  loading: false,
  error: null,
};

const USERSPWDCHANGEUpdateReducer = (state = updateStateSingle, action) => {
  const { type, data, err } = action;
  switch (type) {
    
    case USERSPWDCHANGE_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case USERSPWDCHANGE_UPDATE_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case USERSPWDCHANGE_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export {  USERSPWDCHANGEUpdateReducer };
